import * as ents from '@attain-apps/entities'
import type * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as me from '../../../../../me'
import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const displayReportOnRequest = store.effects.create(
  (
    feature: Plugin['feature'],
    plugin: Plugin,
    meFeature: me.Feature,
    _router: router.Router,
  ) =>
    feature.actions.display.relay((forwardTo, request) => {
      let id$: rxjs.Observable<string | undefined>
      switch (request) {
        case 'first':
          id$ =
            plugin.collection.plugins.currentListPlugin.feature.selectors
              .firstId.asObservable
          break
        case 'last':
          id$ =
            plugin.collection.plugins.currentListPlugin.feature.selectors.lastId
              .asObservable
          break
        case 'next':
          id$ =
            plugin.collection.plugins.currentEntityPlugin.feature.selectors.getNextId()
              .asObservable
          break
        case 'previous':
          id$ =
            plugin.collection.plugins.currentEntityPlugin.feature.selectors.getPreviousId()
              .asObservable
          break
        default:
          id$ = rxjs.of(request.id)
          break
      }
      return id$.pipe(
        // Just uses the current value
        rxjs.take(1),
        rxjs.switchMap(id =>
          id === undefined
            ? rxjs.of({
                cancellation:
                  typeof request === 'string'
                    ? `There is no '${request}' report`
                    : 'Failed to identify the requested report',
              })
            : meFeature.contexts.selectors
                .getUrlForLink({
                  goto: {
                    navigationId: 'report',
                  },
                })
                .asObservable.pipe(
                  rxjs.take(1),
                  rxjs.filter(TypeChecker.isNotNullish.raw),
                  rxjs.switchMap(url =>
                    rxjs.from([
                      // Focus on the report
                      forwardTo(
                        plugin.collection.plugins.currentEntityPlugin.storage
                          .actions.putInIdLookup,
                        { input: { value: id } },
                      ),
                      // And navigate to the report details page
                      forwardTo(_router.actions.navigate, {
                        input: { url },
                      }),
                    ]),
                  ),
                ),
        ),
      )
    }).asObservable,
)
